<template>
  <div class="sac-toggle-switch-container">
    <label class="sac-toggle-switch">
      <input
        type="checkbox"
        class="sac-toggle-checkbox"
        :checked="checked"
        :disabled="disabled"
        @change="onChange"
      />
      <span class="sac-toggle-slider round" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'SACToggleSwitch',
  props: {
    checked: Boolean,
    change: Function,
    disabled: Boolean,
  },
  methods: {
    onChange(event) {
      event.target.checked = this.checked;

      this.change?.(event);
    },
  },
};
</script>

<style lang="scss">
.sac-toggle-switch-container {
  display: flex;
  align-items: center;
  .sac-toggle-switch {
    position: relative;
    display: inline-block;
    width: 35px;
    height: 19px;
    .sac-toggle-checkbox {
      opacity: 0;
      width: 0;
      height: 0;
      &:checked + .sac-toggle-slider {
        background-color: $NBLUE100;
      }
      &:focus + .sac-toggle-slider {
        box-shadow: 0 0 1px $NBLUE100;
      }
      &:checked + .sac-toggle-slider:before {
        transform: translateX(14px);
      }
      &:disabled + .sac-toggle-slider:before {
        background-color: $N50;
      }
      &:disabled + .sac-toggle-slider {
        background-color: $N20;
        cursor: default;
      }
    }
    .sac-toggle-slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: $N30;
      transition: 0.4s;
      border-radius: 34px;
      &:before {
        position: absolute;
        content: '';
        height: 15px;
        width: 15px;
        left: 3px;
        top: 2px;
        background-color: white;
        border-radius: 35px;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
  }
}
</style>
